import React from 'react';
import { findDOMNode } from 'react-dom';

export default class SearchInput extends React.Component {
    static defaultProps = { placeholder: 'Search..' };
    search(e) {
        e.preventDefault();
        this.props.onSearch(findDOMNode(this.refs.searchTerm).value);
    }
    handleClick(e) {
        var elementBounds = e.target.getBoundingClientRect();

        // User has clicked on the little (x) button in the search field so clear input and reset search results
        if( e.clientX > (elementBounds.right - 20) ) {
            // clear the input (the user might have clicked within the bounds to clear search but not clicked the clear search button)
            findDOMNode(this.refs.searchTerm).reset();
            this.props.onSearch('');
        }
    }
    scheduleSearch(e) {
        clearTimeout(this.updateTimer);
        this.updateTimer = setTimeout(() => {
            this.props.onSearch(this.refs.searchTerm.value);
        }, 800);
    }
    render() {
        return (
            <form onSubmit={this.search.bind(this)}>
                <div className="input-group">
                    <span className="input-group-addon">
                        <i className="fa fa-search"></i>
                    </span>
                    <input type="search"
                       className="form-control"
                       onClick={this.handleClick.bind(this)}
                       onKeyDown={this.scheduleSearch.bind(this)}
                       ref="searchTerm"
                       onBlur={this.search.bind(this)}
                       defaultValue={this.props.searchText}
                       placeholder={this.props.placeholder} />
                </div>
            </form>
        );
    }
}




// WEBPACK FOOTER //
// ./app/components/SearchInput.js